(function () {
  'use strict';

  angular.module('ringbaPortal').directive('ngWheelBlur', function () {
    return {
      restrict: 'A',
      link: function (scope, element) {
        element.on('wheel', function (event) {
          event.target.blur(); // Remove focus from the input to prevent value changes on scroll
        });

        // Clean up the event listener when the element is destroyed
        scope.$on('$destroy', function () {
          element.off('wheel');
        });
      }
    };
  });
})();